<div class="flex flex-col items-center px-6 pt-8 pb-6 text-center">
	<button
		class="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 text-gray-500 active:bg-gray-200 transition-colors"
		(click)="dismiss()">
		<ion-icon name="close-outline" class="text-lg"></ion-icon>
	</button>

	<h2 class="text-[#1a1a1a] font-bold text-xl">{{ message | translate }}</h2>

	<ion-button expand="block" class="w-full h-12 font-semibold normal-case rounded-xl" (click)="dismiss()">
		{{ 'Got it' | translate }}
	</ion-button>
</div>
